// extracted by mini-css-extract-plugin
module.exports = {"container":"Ul","bubbleNav":"Vl","graphic":"Wl","container404":"Xl","container500":"Yl","contact":"Zl"};